// Vendor Libs
import moment from 'moment-timezone';
var defaultDateFormat = 'MM/DD/YY';
var defaultDurationFormat = 'h m s';
var defaultDurationUnit = 'seconds';
var defaultParseFormats = [moment.ISO_8601, 'YYYY-MM-DD', 'x'];
var defaultTimezoneFormat = 'MM/DD/YYYY hh:mm:ss A z';
var durationSplitRegex = /[\s]*([\d]+)[\s]*([dhms])[\s]*/i;
var durationSplitGroupRegex = /[\s]*([\d]+[\s]*[dhms])[\s]*/i;
export var isValidDate = function isValidDate(date, formats) {
  if (formats === void 0) {
    formats = defaultParseFormats;
  }

  return (// Use strict parsing
    moment(date, formats, true).isValid()
  );
};
export var parseDate = function parseDate(dateString, formats) {
  if (formats === void 0) {
    formats = defaultParseFormats;
  }

  return isValidDate(dateString, formats) ? moment(dateString, formats) : null;
};
export var formatDate = function formatDate(dateString, format, parseFormats, invalidDate) {
  if (format === void 0) {
    format = defaultDateFormat;
  }

  if (parseFormats === void 0) {
    parseFormats = defaultParseFormats;
  }

  var date = parseDate(dateString, parseFormats);
  return date !== null ? date.format(format) : invalidDate;
};
export var formatTimezone = function formatTimezone(dateString, format, timezone, parseFormats, invalidDate) {
  if (format === void 0) {
    format = defaultTimezoneFormat;
  }

  if (parseFormats === void 0) {
    parseFormats = defaultParseFormats;
  }

  var date = parseDate(dateString, parseFormats);
  return date !== null ? date.tz(timezone || moment.tz.guess()).format(format) : invalidDate;
};
export var formatDuration = function formatDuration(durationString, format, durationUnit, invalidDuration) {
  if (format === void 0) {
    format = defaultDurationFormat;
  }

  if (durationUnit === void 0) {
    durationUnit = defaultDurationUnit;
  }

  var results = [];
  var duration = moment.duration(Number(durationString), durationUnit);
  format.split(' ').forEach(function (unit) {
    var unitValue = duration.get(unit);

    if (unitValue) {
      results.push("" + unitValue + unit);
    }
  });
  return results.length ? results.join(' ') : invalidDuration;
};
export var parseDuration = function parseDuration(durationString) {
  if (durationString === void 0) {
    durationString = '';
  }

  var durationParts = {};

  if (durationString !== null) {
    durationString.split(durationSplitGroupRegex).forEach(function (part) {
      if (part !== '') {
        var match = durationSplitRegex.exec(part);

        if (match !== null && match.length > 2) {
          var unit = match[2].toLowerCase();

          if (durationParts[unit]) {
            durationParts = {};
            return false;
          }

          durationParts[unit] = match[1];
        } else {
          durationParts = {};
          return false;
        }
      }
    });
  }

  var result = moment.duration(durationParts);
  return result.as(defaultDurationUnit) > 0 ? result : null;
};
export var isValidDuration = function isValidDuration(durationString) {
  return parseDuration(durationString) !== null;
};
export var parseDurationAs = function parseDurationAs(durationString, unit) {
  var duration = parseDuration(durationString);
  return duration !== null ? duration.as(unit) : null;
};